import React, { useContext } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { navBarContext } from '../../../contexts/navBarContext';

import Hamburger from '../../utility/Hamburger';
// import UserIcon from '../../utility/UserIcon';

const TopNav = ({ sideNavVisibility }) => {
  const {
    toggleSideNav,
    navBarState: { topNavMiddleContent }
  } = useContext(navBarContext);
  return (
    <TopNavContainer
      animate={sideNavVisibility ? 'pushToRight' : 'default'}
      variants={{ pushToRight: { x: 200 }, default: { x: 0 } }}
    >
      <Hamburger onClick={toggleSideNav} />
      {topNavMiddleContent}
      <div />
      {/* <UserIcon
        onClick={() => {
          // Handle Login Modal Here
        }}
      /> */}
    </TopNavContainer>
  );
};

const TopNavContainer = styled(motion.div)`
  display: flex;
  padding: 0 1.5rem;
  align-items: center;
  justify-content: space-between;
  height: 5rem;
  font-size: 1rem;
`;

export default TopNav;
